import { render } from "./codigodescuento.vue?vue&type=template&id=0f4fdbc4&scoped=true"
import script from "./codigodescuento.vue?vue&type=script&lang=js"
export * from "./codigodescuento.vue?vue&type=script&lang=js"

import "./codigodescuento.vue?vue&type=style&index=0&id=0f4fdbc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4fdbc4"]])

export default __exports__